export default function applyOmnibusWhiteText () {
    if (!document.querySelector('.js-shopByMoodButton.button-primary-white-outline.selected')) {
        return;
    }

    document.querySelectorAll('.cc-omnibusStack.cc-omnibusStack_listing2, .cc-omnibusStack.cc-omnibusStack_listing2 .cc-omnibusStack-item.price-info-pdp-container').forEach((element) => {
        element.classList.add('cc-whiteText');
    });
}
